import { cronosClient } from "@/config/client"
import type { CourseTargetObjetive } from "./get"

export function updateTargetObjetive(courseId: string, targetObjective: CourseTargetObjetive) {
  return cronosClient.put(`/v1/courses/${courseId}/target-objective`, {
    targetObjective,
  })
}
